import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useChat } from "~/components/Chat/useChat";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions";
import { canAccessChat } from "~/store/selectors/selector.users";
import { ChatControlContextProvider } from "./ChatControlsContext.js";

export const ChatControlsProvider = ({ children }) => {
  const {
    loading,
    conversationId,
    setConversationId,
    defaultMessagesSound,
    defaultChatShortcuts,
    onToggleMessagesSound,
    onToggleChatShortcuts,
    draft,
    setDraft,
  } = useChat();

  const isChatEnabled = useSelector((state) => getRawConfigOption(state, "chat_enabled"));
  const canUserAccessChat = useSelector(canAccessChat);

  return isChatEnabled && canUserAccessChat ? (
    <ChatControlContextProvider
      value={{
        loading,
        conversationId,
        setConversationId,
        defaultMessagesSound,
        defaultChatShortcuts,
        onToggleMessagesSound,
        onToggleChatShortcuts,
        draft,
        setDraft,
      }}
    >
      {children}
    </ChatControlContextProvider>
  ) : (
    children
  );
};

ChatControlsProvider.propTypes = {
  children: PropTypes.any,
};
